module.exports = __webpack_public_path__ + "img/custom.fec2fb6a.png";